import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { ArrowBackRounded } from '@mui/icons-material';
import { layoutIconButtonRadius } from '../../theme/colors';

const BACK_SLOT = 40;

export const PageBackButton = ({ onClick }) => (
  <ButtonBase
    data-no-shadow="true"
    aria-label="Voltar"
    onClick={onClick}
    sx={{
      color: 'text.primary',
      borderRadius: layoutIconButtonRadius,
      width: BACK_SLOT,
      height: BACK_SLOT,
      m: 0,
      flexShrink: 0,
      overflow: 'hidden',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        bgcolor: 'action.hover',
      },
    }}
  >
    <ArrowBackRounded />
  </ButtonBase>
);

const PageHeader = ({ title, onBack }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'stretch',
      width: '100%',
      minHeight: BACK_SLOT,
      mb: 1,
    }}
  >
    {onBack ? (
      <PageBackButton onClick={onBack} />
    ) : (
      <Box sx={{ width: BACK_SLOT, height: BACK_SLOT, ml: -1, flexShrink: 0 }} aria-hidden />
    )}

    <Typography
      variant="pageTitle"
      sx={{
        flex: 1,
        textAlign: 'center',
        minWidth: 0,
        px: 0.5,
      }}
    >
      {title}
    </Typography>

    <Box sx={{ width: BACK_SLOT, height: BACK_SLOT, mr: -1, flexShrink: 0 }} aria-hidden />
  </Box>
);

export default PageHeader;
